import styled from 'styled-components';

export const CollapsibleContainer = styled.div`
  width: 100%;
`;

export const FolderItem = styled.div`
  background: ${props => props.$level === 0 ? 'rgba(255, 255, 255, 0.02)' : 'transparent'};
  border: ${props => props.$level === 0 ? '1px solid rgba(255, 255, 255, 0.05)' : 'none'};
  border-radius: 8px;
  padding: ${props => props.$level === 0 ? '12px' : '0'};
  transition: all 0.2s ease;

  &:hover {
    background: rgba(255, 255, 255, 0.05);
  }
`;

export const FolderHeader = styled.div`
  display: flex;
  align-items: center;
  padding: 8px 8px;
  border-radius: 6px;
  cursor: ${props => props.$isClickable ? 'pointer' : 'default'};
  transition: all 0.2s ease;
  user-select: none;
  gap: 8px;

  &:hover {
    background: ${props => props.$isClickable ? 'rgba(255, 255, 255, 0.08)' : 'transparent'};
  }

  ${props => props.$isExpanded && props.$isClickable && `
    background: rgba(255, 255, 255, 0.1);
  `}
`;

export const FolderContent = styled.div`
  margin-top: 8px;
  margin-left: 20px;
  border-left: 2px solid rgba(255, 255, 255, 0.1);
  padding-left: 8px;
`;

export const FolderIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  font-size: 16px;
  flex-shrink: 0;
`;

export const ExpandIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  font-size: 12px;
  color: rgba(255, 255, 255, 0.6);
  transition: transform 0.2s ease;
  transform: ${props => props.$isExpanded ? 'rotate(0deg)' : 'rotate(-90deg)'};
  flex-shrink: 0;
`;

export const FolderName = styled.h3`
  color: #FFFFFF;
  font-size: 16px;
  font-weight: 600;
  margin: 0;
  flex: 1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const CardCount = styled.span`
  color: rgba(255, 255, 255, 0.6);
  font-size: 12px;
  font-weight: 500;
  background: rgba(255, 255, 255, 0.1);
  padding: 2px 8px;
  border-radius: 12px;
  white-space: nowrap;
`;

export const CardItem = styled.div`
  display: flex;
  align-items: center;
  padding: 6px 12px;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.2s ease;
  gap: 12px;
  margin-left: ${props => props.$level * 20}px;
  background: rgba(255, 255, 255, 0.02);
  border: 1px solid rgba(255, 255, 255, 0.05);

  &:hover {
    background: rgba(255, 255, 255, 0.08);
    border-color: rgba(255, 255, 255, 0.2);
    transform: translateX(4px);
  }
`;

export const CardName = styled.span`
  color: #FFFFFF;
  font-size: 14px;
  font-weight: 500;
  flex: 1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const CardTeam = styled.span`
  color: rgba(255, 255, 255, 0.7);
  font-size: 12px;
  font-weight: 400;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 200px;
`;

// Card display components copied from SetDetailPage
export const CardDisplayContainer = styled.div`
  align-items: center;
  background-color: ${props => props.$isCollected === false 
    ? 'rgba(255, 193, 7, 0.1)' 
    : 'rgba(255,255,255,0.25)'};
  border: 1px solid ${props => props.$isCollected === false 
    ? 'rgba(255, 193, 7, 0.4)' 
    : 'rgba(255,255,255,0.5)'};
  border-radius: 8px;
  box-sizing: border-box;
  color: #FFFFFF;
  display: flex;
  gap: 16px;
  justify-content: space-between;
  padding: 8px;
  transition: all 0.2s ease;
  margin: 4px 0;
  opacity: ${props => props.$isCollected === false ? '0.85' : '1'};

  &:hover {
    background: ${props => props.$isCollected === false 
      ? 'rgba(255, 193, 7, 0.15)' 
      : 'rgba(255, 255, 255, 0.3)'};
    border-color: ${props => props.$isCollected === false 
      ? 'rgba(255, 193, 7, 0.6)' 
      : 'rgba(255, 255, 255, 0.7)'};
  }
`;

export const LeftCardContent = styled.div`
  align-items: center;
  display: flex;
`;

export const CardNumber = styled.div`
  box-sizing: border-box;
  align-items: center;
  display: flex;
  height: 40px;
  width: 80px;

  h4 {
    font-size: 12px;
    padding: 4px 12px;
  }
`;

export const CardDetails = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const CardHeader = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
  gap: 4px;

  span {
    color: rgba(255,255,255,0.4);
  }

  h3 {
    color: white;
    font-size: 12px;
    font-weight: 600;
  }
`;

export const AttributesContainer = styled.div`
  display: flex;
  gap: 4px;
  flex-wrap: wrap;

  .card-attributes-container, .card-variations-container {
    display: flex;
    gap: 4px;
  }

  h4 {
    font-size: 10px;
  }
`;

export const ButtonContainer = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
`;

export const RemoveButton = styled.button`
  background-color: rgba(220, 38, 38, 0.2);
  border: 1px solid rgba(220, 38, 38, 0.4);
  border-radius: 4px;
  color: rgba(255, 255, 255, 0.9);
  cursor: pointer;
  padding: 4px 12px;
  transition: all 0.2s ease;
  white-space: nowrap;

  &:hover:not(:disabled) {
    background-color: rgba(220, 38, 38, 0.3);
    border-color: rgba(220, 38, 38, 0.6);
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  h4 {
    margin: 0;
    font-size: 10px;
    font-weight: 500;
    white-space: nowrap;
  }
`;

export const ViewButton = styled.div`
  border: ${(props) => `1px solid ${props.$isActive ? '#FFFFFF' : '#FFFFFF66'}`};
  border-radius: 4px;
  cursor: ${(props) => props.$isActive ? 'pointer' : 'default'};
  opacity: ${(props) => props.$isActive ? '1.0' : '0.25'};
  padding: 4px 12px;
  width: fit-content;
  white-space: nowrap;

  h4 {
    width: 100%;
    margin: 0;
    font-size: 10px;
    font-weight: 500;
    white-space: nowrap;
  }
`;
